export const ViewBrandTabs = [
    { label: 'Brand Owner Details' },
    { label: 'Brand Details' },
    { label: 'Brand Contacts' },
    { label: 'Channel Details' },
    { label: 'Address' },
    { label: 'Tekx Contact Details' },
    { label: 'Uploaded Documents' }
]